
import StrategyService from '../../services/strategies'

export const state = {}

export const mutations = {}


export const getters = {}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // eslint-disable-next-line no-unused-vars
  createCustomStrategy ({ commit }, payload) {

    return new Promise((resolve, reject) => {
      
      StrategyService.createCustomStrategy(payload).then(response => { 
        if (response.data && response.data.data?._id) { 
          resolve(response)
        }else{
          reject({message: 'Error creating group'})
        }
      })
      .catch(error => { reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getCustomStrategies({ commit },params) {

    return new Promise((resolve, reject) => { 
      StrategyService.getCustomStrategies(params).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },
  
  // eslint-disable-next-line no-unused-vars
  deleteCustomStrategy({ commit }, id) {

    return new Promise((resolve, reject) => { 
      StrategyService.deleteCustomStrategy(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getCustomStrategy({ commit }, id) {

    return new Promise((resolve, reject) => { 
      StrategyService.getCustomStrategy(id).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  updateCustomStrategy ({ commit }, strategy) {

    return new Promise((resolve, reject) => { 
      StrategyService.updateCustomStrategy(strategy).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getCategoriesMapping({ commit }, projectId) {
    return new Promise((resolve, reject) => { 
      StrategyService.getCategoriesMapping(projectId).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  previewRelatedProducts({ commit }, payload) {
    return new Promise((resolve, reject) => {
      StrategyService.previewRelatedProducts(payload).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  runRecoTest({ commit }, payload) {
    return new Promise((resolve, reject) => {
      StrategyService.runRecoTest(payload).then(response=> {
        resolve(response.data)
    })
    .catch(error=>{ reject(error) })
    });
  },

  // eslint-disable-next-line no-unused-vars
  getStrategyAiConfig({ commit }, payload) {
    return StrategyService.getStrategyAiConfig(payload).then(response => response.data?.data)
  },

  // eslint-disable-next-line no-unused-vars
  createStrategyAiRun({ commit }, payload) {
    return StrategyService.createStrategyAiRun(payload).then(response => response.data?.data)
  },

  // eslint-disable-next-line no-unused-vars
  getStrategyAiRun({ commit }, payload) {
    return StrategyService.getStrategyAiRun(payload).then(response => response.data?.data)
  },

  // eslint-disable-next-line no-unused-vars
  listStrategyAiRuns({ commit }, payload) {
    return StrategyService.listStrategyAiRuns(payload).then(response => response.data?.data)
  },

  // eslint-disable-next-line no-unused-vars
  cancelStrategyAiRun({ commit }, payload) {
    return StrategyService.cancelStrategyAiRun(payload).then(response => response.data?.data)
  },

  // eslint-disable-next-line no-unused-vars
  applyStrategyAiRun({ commit }, payload) {
    return StrategyService.applyStrategyAiRun(payload).then(response => response.data?.data)
  },

  // eslint-disable-next-line no-unused-vars
  dismissStrategyAiRun({ commit }, payload) {
    return StrategyService.dismissStrategyAiRun(payload).then(response => response.data?.data)
  }
}
